import type { BrowserOptions } from '@sentry/react';

const PII_KEYS = ['forwarded', '-ip', 'remote-', 'via', '-user'];

/**
 * Sentry 11 collects cookies, request/response bodies, headers and user info
 * unless told otherwise. This restores the restrictive v10 default
 * (`sendDefaultPii` unset), as given in Sentry's v11 migration guide.
 */
export const SENTRY_DATA_COLLECTION: NonNullable<
    BrowserOptions['dataCollection']
> = {
    userInfo: false,
    cookies: false,
    httpHeaders: {
        request: { deny: PII_KEYS },
        response: { deny: PII_KEYS },
    },
    httpBodies: [],
    urlQueryParams: { deny: PII_KEYS },
    genAI: { inputs: false, outputs: false },
    databaseQueryData: false,
    queues: false,
    graphQL: { document: false, variables: false },
};
